export default __webpack_public_path__ + "static/media/cards4.9079bb83.png";